import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const updateEmployeeDirectoryImport = (
  employeeDirectoryImportId: number,
  update: EmployeeDirectoryImportUpdateRequest,
  isSendEmail?: number,
) =>
  createGenericDispatcher<EmployeeDirectoryImport>({
    name: 'UPDATE_EMPLOYEE_DIRECTORY_IMPORT',
    loadFunction: () =>
      Api.post(
        `/employee-directory-import/${employeeDirectoryImportId}?sendCustomerEmail=${
          isSendEmail || 0
        }`,
        {
          body: JSON.stringify({ ...update }),
        },
      ),
    args: { employeeDirectoryImportId, update },
  });
